import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './BotItem.module.css'
import { Affix, Avatar, Button, Card, Divider, Flex, message, Space, Tag } from 'antd'
import classNames from 'classnames'
import { getVideoPlayerAuthRequest } from './MSGZSListApi'
import Aliplayer from 'aliyun-aliplayer'
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css'
import {
  EditOutlined,
  EllipsisOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons'
import videoPlayerIcon from './videoPlayerIcon.svg'

var player
export default function BotItem(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;
  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    console.log('---------->>aslkdfj')
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  return (
    <Card
      style={{
        width: '30%',
        marginBottom: '20px',
        marginRight: '1.5%',
        marginLeft: '1.5%',
        paddingBottom:40
      }}
      onClick={(e) => {
        props.clickBotMethod(props.info)
      }}
      hoverable={true}
    >
      <Card.Meta 
      avatar={<Avatar src={props.info.icon_url} />}
      title={props.info.bot_name}
      // description={props.info.description}
      
      description={<div className={styles.description}>{props.info.description}</div>}
      />
      <Flex justify="flex-start" style={{position:'absolute',bottom:20,marginLeft:50}}>
        <text style={{ color: '#9da4b1',width:80 }}>@{props.info.name}</text>
        <text style={{ color: '#9da4b1',marginLeft:'10px' }}>
          <UserOutlined />
          {props.info.open_time}</text>
      </Flex>
    </Card>
  )
}
